module.exports = __webpack_public_path__ + "img/06-7.c8908d43.png";